import { useQuery } from '@tanstack/react-query';
import { supportTicketServices } from '../services/support-ticket.service';

export const useSupportTickets = ({
  page,
  limit,
  status,
  category,
  priority,
  isEscalated,
  search,
  sortBy,
  sortOrder,
  startDate,
  endDate,
}) => {
  return useQuery({
    queryKey: [
      'support-tickets',
      { page, limit, status, category, priority, isEscalated, search, sortBy, sortOrder, startDate, endDate },
    ],
    queryFn: () =>
      supportTicketServices.getSupportTickets({
        page,
        limit,
        status,
        category,
        priority,
        isEscalated,
        search,
        sortBy,
        sortOrder,
        startDate,
        endDate,
      }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    keepPreviousData: true,
  });
};
